export const studio = {
  props: {},

  SectionHgroup: {},

  ProductRow: {},

  Footer: { margin: 'auto - -' }
}
